import { useHistory } from 'react-router-dom';

import Button from '@mui/material/Button';
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';

import { ReactComponent as RightUpArrowIcon } from "../../svg/rightUpArrowIcon.svg";
import { ReactComponent as Robot } from "../../svg/robotIcon.svg";
import { ReactComponent as SprinkleIcon } from "../../svg/sprinkleIcon.svg";
import styles from "./EmptyCookingHistory.module.css"

const EmptyCookingHistory = () => {
    const history = useHistory();
    const homePage = () => {
        const url = `/`;
        history.push(url);
    }
    return (
        <Grid className={styles.boxColor}>
            <Grid className={styles.box}>
                <Robot />
                <Grid className={styles.textBox}>
                    <Typography className={styles.textLineHeight} variant="button" >
                        Your history is empty.
                    </Typography>
                    <Typography variant="caption3Light" >
                        Start cooking with Upliance to see your delicious creations in this space!
                    </Typography>
                </Grid>
                <Button className={styles.button} onClick={homePage}  >
                    <SprinkleIcon />
                    <Typography className={styles.buttonText} variant='caption3Light'>Explore New Recipes</Typography>
                    <RightUpArrowIcon />
                </Button>
            </Grid>
        </Grid>
    )
}

export default EmptyCookingHistory